import { Fab, Typography, Tooltip } from "@mui/material"
import Badge from "@mui/material/Badge";
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';
import { MapContext } from "../../../store/context";
import { useContext, useEffect, useState } from "react";

import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { RedrawMap } from "../../../utils/MapUtils";
import '../../../utils/mapbox-gl-draw.css'
import 'mapbox-gl/dist/mapbox-gl.css';
import * as settings from "../../../settings"

import ContentCutIcon from '@mui/icons-material/ContentCut';
import NorthWestIcon from '@mui/icons-material/NorthWest';
import ClearIcon from '@mui/icons-material/Clear';
import InfoIcon from '@mui/icons-material/Info';

import axios from "axios";
import { StyledMenu } from "./MenuStyle";
var polyline = require('@mapbox/polyline');



export default function CutBlocks(props) {
    const ctx = useContext(MapContext)
    const plan = ctx.plan
    const map = ctx.map

    const mapSettings = ctx.settings
    const [draw, setDraw] = useState()
    const [active, setActive] = useState(false)
    const [cutActive, setCutActive] = useState(false)
    const [color, setColor] = useState('primary')
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleSelectBlocks = () => {
        setActive(true)
        setAnchorEl(null)
        setColor('secondary')
        // should there be some other sort of indication that shows
        // how many blocks are selected? like a little notification
        // or count attached to cut? also the cut color should change
        // when you're doing something with it
    }

    const handleCutBlocks = () => {
        // switches states to enable the cutting to happen
        setActive(false)
        setAnchorEl(null)
        setCutActive(true)
    }

    const handleAddBlocks = (b) => {
        // ensures no dup ids or geoms are passed to states
        if (b) {
            mapSettings.setSelectedBlockIDs(prev => Array.from(new Set(prev).add(b.properties.blockgeo_id)))

            mapSettings.setSelectedBlocks(prev => Array.from(new Set(prev).add({ type: 'Feature', geometry: b.geometry })))
        }
    }

    const handleDeselectBlocks = () => {
        // deselect all blocks, both as prop and in layer
        var feats = {
            'type': 'FeatureCollection',
            'features': []
        };
        map.getSource('blocks-to-cut').setData(feats)
        setAnchorEl(false)
        setActive(false)
        setCutActive(false)
        setColor('primary')
        mapSettings.setSelectedBlockIDs([])
        mapSettings.setSelectedBlocks([])
    }

    useEffect(() => {
        if (map) {
            setDraw(new MapboxDraw({ displayControlsDefault: false, defaultMode: 'draw_line_string' }))
        }
    }, [map])

    useEffect(() => {
        if (draw && cutActive) {
            map.addControl(draw)
            map.on('draw.create', (e) => {
                var pline = polyline.encode(e.features[0].geometry.coordinates)
                axios.post(`${settings.API_SERVER}/api/geometry/cut/`, {
                    data: {
                        plan_id: plan,
                        polyline: pline,
                        blocks: mapSettings.selectedBlockIDs,
                    }
                }, {
                    headers: { 'Authorization': `Token ${localStorage.getItem('token')}`, }
                }).then((res) => {
                    RedrawMap(map)
                    draw.delete(e.features[0].id).getAll() // clears drawn features                    
                    handleDeselectBlocks()
                    setColor('primary')
                }).catch((e) => { console.log(e) })
            })
        }
    }, [draw, cutActive])

    useEffect(() => {
        if (active) {
            map.on('click', 'plan-layer', (e) => {
                handleAddBlocks(e.features[0])
            })
        }
    }, [active])


    useEffect(() => {
        if (map && active) {
            var feats = {
                'type': 'FeatureCollection',
                'features': mapSettings.selectedBlocks
            };
            map.getSource('blocks-to-cut').setData(feats)
        }
    }, [mapSettings.selectedBlocks, active])

    return (
        <>
            <Button>
                <Fab size="medium" color={color}
                    disabled={false}
                    onClick={handleClick}>
                    <ContentCutRoundedIcon color="#000" />
                </Fab>
            </Button>
            <StyledMenu anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                sx={{ marginLeft: '1em' }}
            >
                <MenuItem onClick={handleSelectBlocks}>
                    <Tooltip title='Select blocks to cut.' placement="right">
                        <Badge badgeContent={mapSettings.selectedBlockIDs.length} color='secondary'>
                            <NorthWestIcon />
                        </Badge>
                    </Tooltip>

                </MenuItem>
                <MenuItem onClick={handleCutBlocks}>
                    <Tooltip title='Draw a line to cut blocks. Double-click to finish' placement='right'>
                        <ContentCutIcon />
                    </Tooltip>

                </MenuItem>
                {
                    mapSettings.selectedBlocks.length > 0 ? (
                        <MenuItem onClick={handleDeselectBlocks}>
                            <Tooltip title='Clear selected blocks' placement="right">
                                <ClearIcon />
                            </Tooltip>

                        </MenuItem>
                    ) : (
                        <MenuItem disabled={true}>

                            <ClearIcon />


                        </MenuItem>
                    )
                }

                <MenuItem>
                    <Tooltip title='Select one or more blocks to split into smaller blocks.
                        Once blocks are selected, use the cut tool to split geometries.' placement='right'>
                        <InfoIcon />
                    </Tooltip>
                </MenuItem>
            </StyledMenu>
        </>

    )
}